<template>
  <SkeletonLoader>
    <div class="ho-skeleton">
      <div class="ho-skeleton__card">
        <div class="sk-line sk-line--title" style="width: 50%;"></div>
        <div class="sk-line" style="width: 90%; margin-bottom: 4px;"></div>
        <div class="sk-line" style="width: 70%; margin-bottom: 16px;"></div>

        <div class="ho-skeleton__table">
          <div class="ho-skeleton__header">
            <div v-for="i in 5" :key="'h-' + i" class="sk-rect" :style="{ height: '14px', width: headerWidths[i] }"></div>
          </div>
          <div v-for="r in 6" :key="'row-' + r" class="ho-skeleton__row">
            <div class="sk-line" :style="{ width: col1[r] }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: col2[r] }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: col3[r] }"></div>
            <div class="sk-line sk-line--sm" :style="{ width: col4[r] }"></div>
            <div class="sk-rect" style="height: 20px; width: 50px; border-radius: 10px;"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default {
  name: 'HygieneOpportunitiesSkeleton',
  components: { SkeletonLoader },
  data() {
    return {
      headerWidths: { 1: '18%', 2: '12%', 3: '15%', 4: '14%', 5: '10%' },
      col1: { 1: '65%', 2: '55%', 3: '70%', 4: '50%', 5: '60%', 6: '45%' },
      col2: { 1: '50%', 2: '65%', 3: '45%', 4: '60%', 5: '55%', 6: '70%' },
      col3: { 1: '40%', 2: '55%', 3: '50%', 4: '45%', 5: '60%', 6: '35%' },
      col4: { 1: '55%', 2: '45%', 3: '60%', 4: '50%', 5: '40%', 6: '55%' },
    };
  }
}
</script>

<style lang="scss" scoped>
.ho-skeleton {
  padding: 16px;
}

.ho-skeleton__card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
}

.ho-skeleton__table {
  margin-top: 12px;
}

.ho-skeleton__header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 2px solid #e2e8f0;
  margin-bottom: 4px;
}

.ho-skeleton__row {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
}

@media (max-width: 768px) {
  .ho-skeleton__header > :nth-child(n+4),
  .ho-skeleton__row > :nth-child(n+4) {
    display: none;
  }
}
</style>
